export default {
    data() {
        return {
            nameSearch: '',
            orderNumSearch: '',
            // 总条数
            total: 0,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            // 订单数据
            orders: [],
            // 控制显示操作订单的窗口的变量
            dialogVisible: false,
            // 某个订单的id
            order_id: '',
            // 订单项数据
            purchasedData: []
        }
    },
    methods: {

        // 获取订单数据
        getOrdersData() {
            //pay_type 1 支付宝 2微信
            //state 0 未付款 2已付款 5已失效
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
                this.orders = res.data.result.data
                this.total = res.data.result.total
                return res.data.result.data;
            });
        },

        // 搜索
        search() {
            //pay_type 1 支付宝 2微信
            //state 0 未付款 2已付款 5已失效
            this.currentPage = 1
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
                this.orders = res.data.result.data
                this.total = res.data.result.total
                return res.data.result.data;
            });
        },

        // 点击取消订单
        cancelOrder(order) {
            this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleCancelOrder(order)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },

        // 取消订单
        handleCancelOrder(order) {
            this.$post('orders/cancel', {
                id: order.id,
                token: this.$store.state.authority_management,
                state: '5'
            }).then(res => {
                if (res.status === 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                }
                this.getOrdersData()
            })
        },

        // 点击操作订单按钮
        show(order) {
            this.dialogVisible = true
            this.order_id = order.id

            // 获取订单项
            this.getPurchased()
            
        },

        // 发送请求，根据订单id获取该订单下的所有订单项
        getPurchased() {
            this.$post('purchased/search_by_order_id', {
                token: this.$store.state.authority_management,
                order_id: this.order_id,
                offset: 0,
                length: 999
            }).then(res => {
                this.purchasedData = res.data.result.data
            })
        },

        // 删除订单项
        deletePurchased(purchased) {
            let id = purchased.id
            this.$confirm('此操作将删除该订单项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('purchased/delete_purchased', {
                    token: this.$store.state.authority_management,
                    id: id,
                    is_delete: 1
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                    // 获取订单项
                    this.getPurchased()
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },

        // 当前页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.getOrdersData()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.getOrdersData()
        }
    },
    mounted() {
        // 获取订单数据
        this.getOrdersData()
    },
}